// @core/api/endpoints/form/duplicate_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DuplicateFormRequest,
  FormResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Duplicate form
 * Creates a copy of an existing form with all pages and fields. The new form is created in draft status.
 */
export async function DuplicateForm(
  form_id: string,
  data: DuplicateFormRequest,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/duplicate`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.post<FormResponse>(requestPath, data, requestOptions);
}
